export interface TelaPlaylistPatch {
  playlist_id: string | null;
  ultima_conexao: string | null;
}

export function telaDeDbChange(payload: unknown): TelaPlaylistPatch | null {
  if (payload === null || typeof payload !== 'object') return null;
  const p = payload as { tabela?: unknown; new?: unknown };
  if (p.tabela !== 'telas' || p.new === null || typeof p.new !== 'object') return null;
  const row = p.new as { playlist_id?: unknown; ultima_conexao?: unknown };
  return {
    playlist_id: typeof row.playlist_id === 'string' ? row.playlist_id : null,
    ultima_conexao: typeof row.ultima_conexao === 'string' ? row.ultima_conexao : null,
  };
}

export function playlistIdMudou(
  anterior: string | null | undefined,
  nova: string | null | undefined,
): boolean {
  return (anterior ?? null) !== (nova ?? null);
}
